import React from 'react';
import '../styles/Footer.scss';
import { useNavigate } from 'react-router-dom';
const Footer: React.FC = () => {
    const navigate = useNavigate();
    const BSI = `${process.env.REACT_APP_S3_URL}iso.svg`;
    const DSS = `${process.env.REACT_APP_S3_URL}dss.svg`;
    const LinkedIn = `${process.env.REACT_APP_S3_URL}LinkedIn-Blue.png`;
    return (
        <div>
            <footer className="footer-container">
                {/* Left Side Logos */}
                <div className="footer-logos">
                    <img src={BSI} alt='' className="footer-logo" />
                    <img src={DSS} alt='' className="footer-logo" />
                </div>

                {/* Links Sections */}
                <div className="footer-links">
                    <div className="footer-section">
                    <h4>PAYMENT SWITCHES</h4>
                    <ul>
                        <li>
                            <a href="/products/upi">UPI</a>
                        </li>
                        <li>
                            <a href="/products/imps">IMPS</a>
                        </li>
                        <li>
                            <a href="/products/bbps">BBPS</a>
                        </li>
                        <li>
                            <a href="/products/aeps">AePS</a>
                        </li>
                    </ul>
                    </div>

                    <div className="footer-section">
                    <h4>API BANKING PLATFORM</h4>
                    <ul>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/TransXT'); window.scrollTo(0, 0);}}
                        >TransXT</li>
                    </ul>
                    </div>

                    <div className="footer-section">
                    <h4>COMPANY</h4>
                    <ul>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/AboutUs'); window.scrollTo(0, 0);}}
                        >About Us</li>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/Careers'); window.scrollTo(0, 0);}}
                        >Careers</li>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/Resources/News'); window.scrollTo(0, 0);}}
                        >Newsroom</li>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/Resources/Blogs'); window.scrollTo(0, 0);}}
                        >Blogs</li>
                        <li
                        className='cursor'
                        onClick={() => {navigate('/PrivacyPolicy'); window.scrollTo(0, 0);}}
                        >Privacy Policy</li>
                    </ul>
                    </div>

                    <div className="footer-section">
                    <h4>FOLLOW US ON</h4>
                    <ul>
                        <li>
                        <a href="https://in.linkedin.com/company/86400-official" target="_blank" rel="noopener noreferrer">
                            <img src={LinkedIn} alt="LinkedIn Logo" className="footer-icon" />
                        </a>
                        </li>
                    </ul>
                    </div>
                </div>
            </footer>
            <div style={{
                borderTop:'1px solid #E2E2E4',
                padding:12,
                textAlign:'center'
            }}>
                <span style={{
                    color: '#869CA7',
                    fontWeight:500,
                    fontSize:'0.9rem'
                }}>
                    Copyright © 2026 Mobileware Technologies
                </span>
            </div>
        </div>
    );
};

export default Footer;
